module.exports = __webpack_public_path__ + "static/cctx-7a4a3ca403d887c5547d7fed90093da1.jpg";